module.exports = __webpack_public_path__ + "media/tv-switch.ba6d471c.mp3";